import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { NotificationType } from "../../../../../apis/networkdashboard/graphql/graphql";
import { DialogTickets } from "../../../../../components/dialogs/dialog-tickets/dialog-tickets";
import { TicketsBadgeButton } from "../tickets-badge-button/tickets-badge-button";

@Component({
  selector: "tickets-item",
  templateUrl: "tickets-item.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TicketsBadgeButton],
})
export class TicketsItem {
  private dialog = inject(MatDialog);

  protected messages = input.required<NotificationType[]>();

  openTicketsDialog() {
    this.dialog.open(DialogTickets, {
      data: { serviceMessages: this.messages() },
    });
  }
}
